module.exports = __webpack_public_path__ + "d4e1cbf53f7712b4da71d5036406f72d.svg";